var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"icon-color--primary",class:{
      'icon-color--highlight-info': _vm.infoVersion,
      'icon-color--lighten4': _vm.disabled
    },attrs:{"d":"M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{staticClass:"icon-color--primary",class:{
      'icon-color--highlight-info': _vm.infoVersion,
      'icon-color--lighten4': _vm.disabled
    },attrs:{"d":"M12 8V13","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{staticClass:"icon-color--primary",class:{
      'icon-color--highlight-info': _vm.infoVersion,
      'icon-color--lighten4': _vm.disabled
    },attrs:{"d":"M11.9946 16H12.0036","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }